import React from 'react';
import InlineAutocomplete from 'react-inline-autocomplete';
import 'react-inline-autocomplete/dist/index.css';
import styled from 'styled-components';

const StyledInlineAutocomplete = styled.div`
  border-radius: 0.375rem;
  background: white;

  .ria-input {
    background-color: transparent;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
  }

  .ria-complete {
    font-size: 16px;
    padding: 4px 1.25rem;
    border-color: white;
    line-height: 54px;
    color: #999;
    background-color: transparent;
    pointer-events: none;
    .small-input & {
      line-height: 39px;
    }
  }
`;

export default function InlineAutocompleteComponent(props) {
  const { form } = props;
  const ref = React.createRef();

  const onChange = value => {
    const match = props.options.filter(({ label }) => label.toLowerCase() === value.toLowerCase()).pop();
    if (match && match.value) {
      form.setFieldValue(props.name, match.value);
    } else {
      form.setFieldValue(props.name, '');
    }
  };

  const dataSource = props?.options
    .filter(option => option.label !== 'Select your state')
    ?.map(option => ({
      text: option.label,
      value: option.value
    }));

  return (
    <StyledInlineAutocomplete>
      <InlineAutocomplete
        ref={ref}
        placeholder={props.placeholder}
        className="inline-autocomplete-example"
        dataSource={dataSource}
        caseSensitive={false}
        onBlur={e => {
          props.form.getFieldHelpers(props.name).setTouched(true);
        }}
        onChange={onChange}
      />
    </StyledInlineAutocomplete>
  );
}
